export type AliasBinding = Record<string, string>

export interface AliasedConstructor {
  _alias: AliasBinding | undefined
}

export interface AliasedEntity {
  constructor: AliasedConstructor
}

export function alias(aliases: string | string[]) {
  return function (target: unknown, key: string) {
    const typed = target as AliasedEntity
    typed.constructor._alias = typed.constructor._alias || {}
    if (Array.isArray(aliases)) {
      for (const alias of aliases) {
        typed.constructor._alias[alias] = key
      }
    } else {
      typed.constructor._alias[aliases] = key
    }
  }
}
